let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fntdq")).then(() => parcelRequire('c9vTU'));